export default "__VITE_ASSET__j$EzGHfI__"